import {Component, Inject, Input, OnInit} from '@angular/core';
import {MyPlan, BML as iBML, ButtonInfo, CtaType, pageTypes, UIFeatureFlag} from '@ox/typings';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {APP_BASE_HREF} from '@angular/common';
import {ShopDataService} from '@webu/data';
import {Router} from '@angular/router';
import {SessionStorageService, WINDOW, buildTrackingString} from '@ox/utils';
import {CheckoutNavigationService} from '../../../services';
import {take} from 'rxjs';
import {Store} from '@ngrx/store';
import {selectFeatureFlag} from '@ox/data';

@Component({
  selector: 'webu-expired-plan-modal',
  templateUrl: './expired-plan-modal.component.html'
})
export class ExpiredPlanModalComponent implements OnInit {
  @Input() expiredPlans: MyPlan[];
  singlePlanExpiryMessage: string;
  multiplePlanExpiryMessage: string;
  shopAllPlansLink: string;
  buttonText: string;
  isNewCheckoutEnabled = false;


  checkoutToggle$ = this.store
  .select(
    selectFeatureFlag({id: UIFeatureFlag.CHECKOUT, group: 'UI'})
  )
  .pipe(take(1))
  .subscribe((response) => {
    if (response) {
      this.isNewCheckoutEnabled = response === 'true';
    }
  });

  //Tracking imports
  trackingString = (cta: CtaType, args: string[]) => buildTrackingString(pageTypes.myPlans, cta, args);
  constructor(
    public bsModalRef: BsModalRef,
    private shopDataService: ShopDataService,
    private session : SessionStorageService,
    private store: Store,
    @Inject(APP_BASE_HREF) private _baseHref: string,
    @Inject(WINDOW) private window: Window,
    private router: Router,
    private checkoutNavigation: CheckoutNavigationService

  ) {}

  ngOnInit() {
    this.getCopy();
  }

  getCopy() {
    this.buttonText = this.shopDataService.getGenericCopy('myplans.renew') ?? '';
    this.shopAllPlansLink = this.shopDataService.getGenericCopy('myplans.expired.plans.modal.shop.plans') ?? '';
    // If 1 plan expired just insert it into the copy
    if (this.expiredPlans.length === 1) {
      this.singlePlanExpiryMessage = this.shopDataService.getGenericCopy('myplans.one.expired.plans.modal.subhead', {planName: this.expiredPlans[0]?.planName}) ?? '';
    }
    // If 2+ plans construct a comma separated string
    else if (this.expiredPlans.length > 1) {
      let commaSeparatedPlanNames = '';
      let i;
      for(i = 0; i < this.expiredPlans.length - 1; i++) {
        commaSeparatedPlanNames += this.expiredPlans[i]?.planName + ', ';
      }
      const firstTwoPlans = this.shopDataService.getGenericCopy('myplans.expired.plans.modal.planNamesList', {
        commaSeparatedPlanNames: commaSeparatedPlanNames,
        lastPlanName: this.expiredPlans[i]?.planName
      });
      if(firstTwoPlans) {
        this.multiplePlanExpiryMessage = this.shopDataService.getGenericCopy('myplans.expired.plans.modal.header', {
          planNamesList: firstTwoPlans
        }) ?? '';
      }
    }
  }

  goToDlp() {
    this.bsModalRef.hide();
    this.router.navigate(['./onstar/shop']);
  }

  goToRenew() {
    this.isNewCheckoutEnabled ? this.goToNewRenew() : this.goToOldRenew();
  }

  //Takes you to legacy manage-plans
  goToOldRenew(){
    this.bsModalRef.hide();
    this.session.setAsJson('plan', this.expiredPlans[0]);
    this.window.location.href = this._baseHref + 'onstar/manage-plans/renew';
  }

  //Takes you to new checkout flow
  goToNewRenew() {
    this.bsModalRef.hide();
    this.checkoutNavigation.goToCheckout([this.expiredPlans[0].planCode], this.router.url, '', undefined, 'PREPAID')
      .pipe(take(1))
      .subscribe({
        error: (err) => {
          throw new Error(err);
        }
    });
  }
}
